<template>
	<div class="booking-form__section background-lightgray">
		<div class="booking-form__section-wrapper">
			<oh-heading
				:caption="componentName"
				:anchor="componentKebab"
				:selection="headerSelect"
				:canVisible="canIIsVisible"
				@toggleVisibility="toggleVisibility"
			/>

			<transition-expand>
				<div class="booking-form__section-details booking-form__appointment flex-horizontal" v-if="isVisible">
					<div class="datepicker__section datepicker__section-date b-column" v-if="!noTerms">
						<b-datepicker
							v-model="selectedDate"
							inline
							:selectable-dates="availableDates"
							:first-day-of-week="1"
							:day-names="$moment.weekdaysShort()"
							@change-month="(x) => (focusedMonth = x)"
							ref="calendar"
						>
							<template slot="header">
								<div class="datepicker-header__data flex-horizontal"></div>
								<div class="datepicker-header__controls flex-horizontal">
									<button class="b-button b-button__control b-button__control-back" @click="$refs.calendar.prev()"></button>
									<span class="content-box content-box-primary content-box-primary-bold" data-v-4105419d="">{{ month }}</span>
									<button class="b-button b-button__control b-button__control-forward" @click="$refs.calendar.next()"></button>
								</div>
							</template>
						</b-datepicker>
					</div>

					<div class="datepicker__section datepicker__section-time b-column flex-vertical" v-if="!noTerms">
						<template v-for="(part, potd) in times">
							<h2 class="datepicker__item datepicker__item-heading left-align heading-caption booking-bold" :key="'caption' + potd">
								{{ $t(`booking.term.${potd}`) }}
							</h2>
							<div class="b-row b-row__time flex-horizontal" :key="'wrap' + potd">
								<div class="b-line b__item b__item-time" v-for="(time, i) in part" :key="potd + i">
									<input
										type="radio"
										class="b__item-input"
										:id="`${potd}_time_${i}`"
										name="times"
										v-model="selectedTime"
										:value="time.id"
										@change="selectTime(time)"
									/>
									<label class="b__item-label" :for="`${potd}_time_${i}`">{{ time.time }}</label>
								</div>
							</div>
						</template>
					</div>
					<div v-else>Vybraný holič nemá k dispozici žádné volné termíny. Vyber si prosím jiného holiče.</div>
					<div class="flex-break" />
					<div class="datepicker__section-control">
						<v-button nativeType="button" :loading="loading" :disabled="!booking.time" v-if="isAuth" @click="createBooking()">
							{{ $t('booking.book') }}
						</v-button>
					</div>
				</div>
			</transition-expand>
		</div>
	</div>
</template>

<script>
import { mapActions } from 'vuex'
import bookingMixin from '../mixins/booking.mixin'
import OhHeading from './heading'

export default {
	name: 'Term',

	mixins: [bookingMixin],

	components: { OhHeading },

	data() {
		return {
			days: [],
			times: [],
			selectedDate: null,
			selectedTime: null,
			focusedMonth: new Date().getMonth(),
			noTerms: false,
		}
	},

	computed: {
		headerSelect() {
			let date = this.date ?? this.booking.date ?? null
			let time =
				(this.selectedTime
					? this._.find(this.times.morning.concat(this.times.afternoon), { id: this.selectedTime }).time
					: this.booking.time?.time) ?? null
			if (time) return this.$moment(date + ' ' + time).format('DD/MM H:mm')
			if (date) return this.$moment(date).format('DD/MM')

			return ''
		},
		availableDates() {
			let dates = []
			this.days.forEach((day) => {
				if (day.hasFreeSlot) dates.push(this.$moment(day.date).toDate())
			})
			return dates
		},
		date() {
			if (!this.selectedDate) return null
			return this.$moment(this.selectedDate).format('YYYY-MM-DD')
		},
		month() {
			return this.$moment.months(this.focusedMonth)
		},
	},

	watch: {
		async selectedDate() {
			if (this.date) {
				let data = await this.set(this.date)
				this.times = data.data
				this.selectedTime = null
				this.scrollIntoView()
			}
		},
	},

	methods: {
		...mapActions({
			set: 'booking/setDate',
			setTime: 'booking/setTime',
		}),
		async selectTime(time) {
			await this.setTime(time.id)
			this.nextStep()
		},

		async getData() {
			let { data } = await this.$http.get(`/bs/${this.booking.id}/dates`)

			this.days = data.dates

			if (!data.firstFree) {
				this.noTerms = true
				return
			}

			if (this.booking.date && this.availableDates.map((x) => this.$moment(x).format('YYYY-MM-DD')).includes(this.booking.date)) {
				this.selectedDate = this.$moment(this.booking.date).toDate()
			} else {
				this.selectedDate = this.$moment(data.firstFree).toDate()
			}
		},
	},
}
</script>
